/** Shake effect on element
 *
 * @param element
 */
export const ui_shake = (element) => {
    element.classList.add('shake');
    setTimeout(() => {
        element.classList.remove('shake');
    }, 500);
}

/** Sous 1024px le formulaire de réservation s'empile sous le calendrier (cf. _gites.scss).
 * @return {boolean}
 */
export const ui_is_small_screen = () => globalThis.matchMedia('(max-width: 1023px)').matches;

/** Amène le haut d'un élément juste sous le header fixe.
 * @param element {Element|null|undefined}
 */
export const ui_scroll_to = (element) => {
    if (!element) return;
    const headerHeight = document.querySelector('header')?.offsetHeight ?? 0;
    const top = element.getBoundingClientRect().top + window.scrollY - headerHeight;
    window.scrollTo({top: Math.max(0, top), behavior: 'smooth'});
}

/* Le poste de développement lui-même, et le réseau local privé : un mobile qui ouvre
 * le site en 192.168.x.x depuis le même Wi-Fi est dans le même environnement de dev. */
const LOOPBACK_HOSTNAMES = ['localhost', '127.0.0.1', '::1'];
const PRIVATE_LAN_IP = /^192\.168\.\d{1,3}\.\d{1,3}$/;

/** @return {boolean} vrai hors production : poste de dev ou réseau local */
export const env_is_local = () => LOOPBACK_HOSTNAMES.includes(document.location.hostname)
    || PRIVATE_LAN_IP.test(document.location.hostname);

/** Adresse d'un service de dev telle que l'appareil qui affiche la page peut l'atteindre.
 * Depuis un mobile du réseau local, « localhost » désignerait le mobile : on vise l'hôte
 * qui sert la page, c'est-à-dire le poste de développement.
 * @param url {string} URL configurée au build (http://localhost:<port>)
 * @return {string} */
export const env_service_url = (url) => env_is_local()
    ? String(url).replace(/^(https?:\/\/)(localhost|127\.0\.0\.1)\b/, `$1${document.location.hostname}`)
    : url;

const host = document.location.hostname;
if (env_is_local() || host.includes('beta') || host.includes('stage.gtnapp.com')) {
    document.body.classList.add('staging');
}
